import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import PropTypes from "prop-types";

const useStyles = makeStyles(() => ({
  chip: {
	borderColor: "#780F9E",
	color: "#780F9E",
	transition: "background-color 0.2s ease, color 0.2s ease",
	"&:hover": {
	  backgroundColor: "#780F9E !important",
	  color: "#FFF",
	},
	"&:focus, &:active": {
	  backgroundColor: "#780F9E !important",
	  color: "#FFF",
	},
  },
  selectedChip: {
	backgroundColor: "#780F9E !important",
	color: "#FFF",
	"&:hover, &:focus, &:active": {
	  backgroundColor: "#5E0C7A !important",
	  color: "#FFF",
	},
  },
}));

const ToggleChips = ({ chipData }) => {
  const classes = useStyles();
  const [selectedChip, setSelectedChip] = useState(0); // Only one selection allowed

  const handleToggle = (chipKey) => {
	setSelectedChip((prev) => (prev === chipKey ? null : chipKey)); // Toggle single selection
  };

  return (
	<div
	  style={{
		padding: 16,
		display: "flex",
		gap: 8,
		flexWrap: "wrap",
		alignItems: "center",
	  }}
	>
	  <strong>Shortcuts: </strong>
	  {chipData.map((chip) => (
		<Chip
		  key={chip.key}
		  label={chip.label}
		  onClick={() => handleToggle(chip.key)}
		  onMouseDown={(e) => e.preventDefault()} // Prevents unwanted focus styling
		  className={selectedChip === chip.key ? classes.selectedChip : classes.chip}
		  variant="outlined"
		/>
	  ))}
	</div>
  );
};

ToggleChips.propTypes = {
  chipData: PropTypes.arrayOf(
	PropTypes.shape({
	  key: PropTypes.number.isRequired,
	  label: PropTypes.string.isRequired,
	})
  ).isRequired,
};

export default ToggleChips;
